import i18n from '@/i18n/i18n';
import type { UserDocumentation } from '@/types/help-docs';

export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export function getFaqsFromI18n(): FAQItem[] {
  const items = i18n.t('faqs:items', { returnObjects: true });
  if (Array.isArray(items)) {
    return items as FAQItem[];
  }
  return [];
}

export function getUserDocsFromI18n(): UserDocumentation {
  const chapters = i18n.t('docs:chapters', { returnObjects: true });
  if (Array.isArray(chapters)) {
    return { chapters } as UserDocumentation;
  }
  return { chapters: [] };
}
